import {Setting} from "./Setting";

export const locationsSetting: Setting = {
    key: "Location",
    title: "Локации",
    description: `Локация — это конкретное место в игровом мире, где происходит взаимодействие персонажей с окружением и другими элементами. Локации могут быть разнообразными, от обширных открытых пространств до замкнутых, детализированных областей, каждая из которых имеет свои особенности, связанные с лором, культурой, экономикой и политикой мира. Локации могут служить как центральными точками для сюжетных событий, так и фоновой средой для исследования, квестов и взаимодействий.`,
    components: [
        {
            title: "Города и поселения",
            subComponents: [
                {
                    title: "Столица",
                    description: `Главный город или столица государства, где сосредоточены власть, торговля, культура и управление.`,
                    examples: ["Столица королевства, где находится дворец и правительство."]
                },
                {
                    title: "Торговые города",
                    description: `Города, где происходит активная торговля, с многочисленными рынками, складами и торговыми гильдиями.`,
                    examples: ["Портовый город, где торгуются редкими товарами и сокровищами."]
                },
                {
                    title: "Деревни и поселки",
                    description: `Малые поселения, часто с ограниченными ресурсами и населением, играющие роль в начале или конце приключений.`,
                    examples: ["Деревня, где живут простые крестьяне и ремесленники."]
                },
                {
                    title: "Крепости и замки",
                    description: `Укрепленные строения, используемые для защиты, хранения ценностей, служащие штабами для армии или правителей.`,
                    examples: ["Старинный замок, где живет злой властелин или прячется древний артефакт."]
                },
                {
                    title: "Магические города или академии",
                    description: `Города, в которых сосредоточена магия, колдуны, алхимики или артефакты. Академии мантии могут служить местами для обучения и практики.`,
                    examples: ["Город волшебников, где проводятся магические эксперименты и обучение."]
                }]
        },
        {
            title: "Природные локации",
            subComponents: [
                {
                    title: "Леса и джунгли",
                    description: `Густые леса, наполненные мистикой, опасностями и скрытыми от мира артефактами или руинами древних цивилизаций.`,
                    examples: ["Темный лес, где обитают древние эльфы и духи природы."]
                },
                {
                    title: "Горы и вулканы",
                    description: `Вершины, опасные для путешественников, часто скрывающие секреты или ценные ресурсы, а также места обитания опасных существ.`,
                    examples: ["Вулканический пик, где спрятан дракон и его клад."]
                },
                {
                    title: "Пустыни и степи",
                    description: `Песчаные или травяные пустоши, где трудные условия выживания создают уникальные ситуации для приключений и конфликтов.`,
                    examples: ["Бескрайняя пустыня, где скрываются древние руины и сокровища."]
                },
                {
                    title: "Острова и архипелаги",
                    description: `Уединенные острова, часто скрывающие сокровища или являющиеся пристанищем для пиратов, тайных обществ и магии.`,
                    examples: ["Таинственный остров, где обитают морские чудовища"]
                }]
        },
        {
            title: "Подземные локации",
            subComponents: [
                {
                    title: "Пещеры и подземелья",
                    description: `Темные, затененные пространства, наполненные опасностями, ловушками и древними сокровищами.`,
                    examples: ["Подземный лабиринт, где обитают гоблины и драконы."]
                },
                {
                    title: "Катакомбы и гробницы",
                    description: `Места, где покоятся древние захоронения, наполненные тайнами прошлого, магическими артефактами и иногда опасными существами.`,
                    examples: ["Катакомбы королевской семьи, где скрывается проклятие."]
                },
                {
                    title: "Заброшенные шахты и фабрики",
                    description: `Покинутые места, где в прошлом велись работы, но теперь являются укрытиями для различных существ или преступников.`,
                    examples: ["Заброшенная шахта, где обитают мутанты и монстры."]
                }]
        },
        {
            title: "Магические локации",
            subComponents: [
                {
                    title: "Магические леса и реки",
                    description: `Локации, где природа и магия переплетаются, создавая необычные явления, магические существа и редкие ресурсы.`,
                    examples: ["Лес, где деревья говорят и ведьмы проводят ритуалы."]
                },
                {
                    title: "Древние храмы и алтарь",
                    description: `Места поклонения древним богам, в которых скрыты мощные магические артефакты или источники энергии.`,
                    examples: ["Храм, где поклоняются древнему богу и проводят жертвоприношения."]
                },
                {
                    title: "Измерения и порталы",
                    description: `Локации, соединяющие различные миры, часто с опасностями и необычными правилами взаимодействия.`,
                    examples: ["Портал в параллельный мир, где правят демоны и ангелы."]
                }]
        },
        {
            title: "Проклятые и заброшенные локации",
            subComponents: [
                {
                    title: "Заброшенные города",
                    description: `Ранее процветающие города, теперь разрушенные и опустошенные, скрывающие свидетельства трагедий или зловещие тайны.`,
                    examples: ["Заброшенный город, где произошла эпидемия и все жители исчезли."]
                },
                {
                    title: "Проклятые земли",
                    description: `Места, где происходят аномальные явления или царит темная магия, а пребывание в них может привести к ужасающим последствиям.`,
                    examples: ["Поляна, где ночью появляются призраки и злые духи."]
                },
                {
                    title: "Разрушенные замки или бастионы",
                    description: `Уничтоженные крепости, наполовину поглощенные природой, которые могут скрывать темные секреты, гневных духов или богатства.`,
                    examples: ["Замок, где живет проклятый рыцарь и его призраки."]
                }]
        },
        {
            title: "Искусственные локации",
            subComponents: [
                {
                    title: "Фабрики и лаборатории",
                    description: `Места, где проводят эксперименты, разрабатывают новые технологии или магические артефакты. Эти локации могут быть как на поверхности, так и под землей.`,
                    examples: ["Фабрика големов, где создаются искусственные существа."]
                },
                {
                    title: "Космические станции или другие планеты",
                    description: `Искусственные сооружения в космосе, исследовательские станции или потерянные корабли, предоставляющие уникальные условия для исследования.`,
                    examples: ["Космическая станция, где проводятся эксперименты над черной дырой."]
                },
                {
                    title: "Мегаполисы и ультра-современные города",
                    description: `Огромные города с высокоразвитыми технологиями, небоскрёбами и автоматизацией, где правят корпорации, а социальное расслоение выражено на каждом шагу.`,
                    examples: ["Город будущего, где все жители живут в виртуальной реальности."]
                }]
        }
    ],
    prompt: {
        component: {
            list: 'Перечисли возможные локации из мира истории и опиши их',
            single: 'Сгенерируй локацию для мира. Опиши ключевые особенности, атмосферу и возможные события',
            extend: 'Дополни описание локации подробностями и разбей на абзацы. Что происходит в локации, какую роль она играет в мире. Перечисли основные свойства локации, которые могут повлиять на сюжет, мир и персонажей.'
        },
        element:{
            list: 'Перечисли возможные локации из мира истории и опиши их',
            single: 'Сгенерируй локацию для мира. Опиши ключевые особенности, атмосферу и возможные события',
            extend: 'Дополни описание локации подробностями и разбей на абзацы. Что происходит в локации, какую роль она играет в мире. Перечисли основные свойства локации, которые могут повлиять на сюжет, мир и персонажей.'
        },
        lore:{
            list: "Создай элементы лора на основе этой локации. Ее историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этой локации. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора локации и разбей на абзацы."
        }
    }
}